import {Directive, ElementRef, inject} from '@angular/core';

@Directive({
	selector: '[autoTabIndexTrap]',
})
export class AutoTabIndexTrapDirective {
	// Trap ID is used to identify the trap in the DOM
	private static trapID = 0;
	public readonly trapID = `auto-tab-index-trap-${AutoTabIndexTrapDirective.trapID++}`;

	public readonly el = inject(ElementRef);
	public tabIndex: number = 0;

	constructor() {
		this.initTrap();
	}

	// מתודה לקבלת אינדקס חדש
	public getTabIndex(): number {
		return this.tabIndex++;
	}

	public restartTrapCycle(): void {
		// open the first element in the trap
		const firstElement = this.el.nativeElement.querySelector('[autotabindex]');
		// if the first element is a button, we need to click it, then focus the next element
		if (firstElement.tagName === 'BUTTON') {
			firstElement.click();
			// after click we want to jump to the next element
			const firstElementTabIndex = firstElement.tabIndex;
			const nextElement = this.el.nativeElement.querySelector(`[autotabindex][tabindex="${firstElementTabIndex + 1}"]`);
			if (nextElement) {
				setTimeout(() => {
					nextElement.focus();
				}, 50);
			}
		} else {
			firstElement.focus();
		}
	}

	private initTrap(): void {
		const trap = this.el.nativeElement;
		trap.tabIndex = this.getTabIndex();
	}
}
